import { useLocation } from 'react-router-dom';
import React, { useMemo, useState } from 'react';
import Container from '@mui/material/Container';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import CustomHeader from '../../General/CustomHeader';
import Page from '../../Layout/Page';
import FullScreenChartShell from '../FullScreenChartShell/FullScreenChartShell';
import useStyles from '../styles';
import RootsChart from './RootsChart';
import RootsConfigContent from './RootsConfigContent';
import { ROOTS_NAME } from '../../../constants/graphs';
import { ReduxState } from '../../../types';
import { generateBreadcrumb } from '../utils';
import { ModalState, EMPTY_MODAL_STATE } from '../chartModal';

const Roots = ({ fullScreen }: { fullScreen?: boolean }) => {
  const classes = useStyles();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);
  const { selectedSector } = useSelector((state: ReduxState) => state.currentSector);

  const [modalState, setModalState] = useState<ModalState>(EMPTY_MODAL_STATE);
  const [conversationsRefreshCounter, setConversationsRefreshCounter] = useState(0);

  const farmId = queryParams.get('farmId') || '';
  const sectorId = queryParams.get('sectorId') || '';

  const breadcrumb = useMemo(() => generateBreadcrumb(
    selectedFarm, selectedSector, ROOTS_NAME, sectorId,
  ), [selectedFarm, selectedSector]);

  if (fullScreen) {
    return (
      <FullScreenChartShell title="Profundidad de Riego">
        {(h) => (
          <RootsChart
            chartView="fullScreen"
            sectorId={sectorId}
            farmId={farmId}
            externalModalState={modalState}
            externalSetModalState={setModalState}
            hideXValues={false}
            height={`${h}px`}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
          />
        )}
      </FullScreenChartShell>
    );
  }

  return (
    <Page className={classes.root} title='Configuración gráfico de profundidad de riego'>
      <Container maxWidth={false}>
        <CustomHeader title={breadcrumb} />
        <Box mt={3}>
          <RootsChart
            chartView="settings"
            sectorId={sectorId}
            farmId={farmId}
            externalModalState={modalState}
            externalSetModalState={setModalState}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
            hideXValues={false}
          />
        </Box>
        <RootsConfigContent
          sectorId={sectorId}
          setModalState={setModalState}
          refreshCounter={conversationsRefreshCounter}
        />
      </Container>
    </Page>
  );
};

export default Roots;
